<script>
  import { features } from '@dabble/app';
  import { planPickerUrl } from '@dabble/data/account-urls';
  import { t } from '@dabble/data/intl';
  import Icon from '@dabble/toolkit/Icon.svelte';
  import { mdiPlayCircle, mdiStopCircle } from '@mdi/js';
  import { reading } from '../reading';
  import SpeedControls from './SpeedControls.svelte';
  import VoiceSelect from './VoiceSelect.svelte';

  $: hasFeature = $features.has('grammar');
</script>

<div class="reading">
  <div class="reading-label">{$t('read_to_me')}</div>
  {#if hasFeature}
    {#if window.speechSynthesis}
      <div class="reading-controls">
        <button class="control-btn icon" on:click={() => ($reading ? reading.stop() : reading.start())}>
          <Icon path={$reading ? mdiStopCircle : mdiPlayCircle} size="30" />
        </button>
        <div class="divider" />
        <SpeedControls />
      </div>
      <VoiceSelect />
    {:else}
      {$t('voice_unavailable')}
    {/if}
  {:else}
    <p>{@html $t('feature_upgrade', { feature: $t('read_to_me') })}</p>
    <a class="btn primary" href={planPickerUrl()}>{$t('feature_upgrade_now')}</a>
  {/if}
</div>

<style>
  .reading-controls {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
  }
  .control-btn {
    font-size: 2rem;
  }
  .divider {
    border-left: var(--form-border);
    height: 1rem;
    margin: 0 0.25rem;
  }
  .reading {
    border-top: var(--side-nav-border);
    padding: 10px;
    margin-bottom: 10px;
    color: var(--text-color-lighter);
  }
  .reading-label {
    flex: 1;
    font-weight: bold;
    font-size: var(--font-size-sm);
  }
</style>
